import { ReactNode } from 'react';

import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

export function HeroSection({
  title,
  subTitle,
  image,
  mobileImage,
  ctaSlot = null,
}: {
  title: string;
  subTitle: string;
  image: SanityImageType;
  mobileImage: SanityImageType;
  ctaSlot?: ReactNode;
}) {
  return (
    <Box as='section' bg='blue.800' position='relative'>
      <ContentContainer>
        <Box
          display={{ base: 'none', lg: 'block' }}
          height='100%'
          left='50%'
          position='absolute'
          top={0}
          transform='translateX(-50%)'
          width='1440px'
        >
          <SanityImage image={image} sizes='1440px' style={{ objectFit: 'cover' }} fill priority />
        </Box>

        <Box display={{ base: 'block', lg: 'none' }} height='100%' left={0} position='absolute' top={0} width='100%'>
          <SanityImage image={mobileImage} sizes='375px' style={{ objectFit: 'cover' }} fill priority />
        </Box>
        <Flex
          alignItems='center'
          color='white'
          flexDirection='column'
          gap='16px'
          margin='auto'
          maxWidth='540px'
          position='relative'
          py={{ base: '94px', lg: '104px' }}
          textAlign='center'
          zIndex={1}
        >
          <Heading as='h1' size='marketing-5xl'>
            {title}
          </Heading>
          <Text marginBottom={10}>{subTitle}</Text>
          {ctaSlot}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
